import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row gx-0 p-4 px-lg-5" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted d-flex vh-100 justify-content-center align-items-center flex-column"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "OCURRIÓ UN ERROR", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, "No pudimos obtener la información solicitada", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "Seleccioná otra opción para resolver el problema", -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "col-12"
}
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}
const _hoisted_9 = { class: "d-flex justify-content-between flex-xl-row flex-column align-items-start" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "text-uppercase fw-bold mb-0" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSkeletonDetail = _resolveComponent("LoadingSkeletonDetail")!
  const _component_TheReserveDay = _resolveComponent("TheReserveDay")!
  const _component_DetailSeccion = _resolveComponent("DetailSeccion")!
  const _component_AppContentButtonsComponent = _resolveComponent("AppContentButtonsComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_LoadingSkeletonDetail)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.t('suVehiculo')), 1),
                _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.navigation.vehiculo?.title), 1),
                _createElementVNode("h6", {
                  class: "text-uppercase",
                  innerHTML: _ctx.navigation.vehiculo?.subtitle
                }, null, 8, _hoisted_12)
              ])
            ]),
            (String(_ctx.getters.tipoActividad) !== 'contacto')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_TheReserveDay),
                  _createVNode(_component_DetailSeccion, {
                    title: _ctx.data.nombre,
                    "sub-title": _ctx.data.subtitulo,
                    imgs: _ctx.data.slider,
                    html: _ctx.data.descripcion,
                    "only-info": Boolean(_ctx.state.evento?.fidelizacion)
                  }, null, 8, ["title", "sub-title", "imgs", "html", "only-info"])
                ], 64))
              : (_openBlock(), _createBlock(_component_DetailSeccion, {
                  key: 1,
                  title: "",
                  "sub-title": "",
                  imgs: _ctx.data.slider,
                  html: _ctx.data.descripcion,
                  "only-info": Boolean(_ctx.state.evento?.fidelizacion)
                }, null, 8, ["imgs", "html", "only-info"])),
            _createVNode(_component_AppContentButtonsComponent, {
              "disabled-return": false,
              "go-back": _ctx.getters.actualActividadURL,
              disabledContinue: !_ctx.getters.actualFormularioURL.hasOwnProperty('name'),
              urlRedirect: _ctx.getters.actualFormularioURL
            }, null, 8, ["go-back", "disabledContinue", "urlRedirect"])
          ]))
  ]))
}